import { baseSepolia, polygon, base, Chain } from "thirdweb/chains";

const getChain = (): Chain => {
  const chainId = import.meta.env.VITE_CHAIN;

  switch (chainId) {
    case "baseSepolia":
      return baseSepolia;
    case "polygon":
      return polygon;
    case "base":
      return base;
    default:
      throw new Error(
        `Unsupported chain ID: ${chainId} please check your .env file`,
      );
  }
};
export const currentChain = getChain();
export const walletDetailsModalConfig = {
  theme: "dark",
  displayBalanceToken: {
    [currentChain.id]: import.meta.env.VITE_USDT_CONTRACT_ADDRESS,
  },
  supportedTokens: {
    [currentChain.id]: [
      {
        address: import.meta.env.VITE_USDT_CONTRACT_ADDRESS,
        name: "USDC",
        symbol: "USDC",
        icon: "https://assets.coingecko.com/coins/images/6319/standard/usdc.png?1696506694",
      },
    ],
  },
  hideBuyFunds: true,
};
